/** Query params a redirect-based payment method lands back on (see `useWebsiteV2Publish`'s `returnUrl`). */
export const CHECKOUT_RETURN_PARAM = 'websiteAiCheckout';
export const CHECKOUT_RETURN_VALUE = 'return';
/** The site to act on, shared by the checkout return and the publish intent. */
export const CHECKOUT_RETURN_SITE_PARAM = 'publishSiteId';
/**
 * `/:handle/edit/website?intent=publish&publishSiteId=<id>`: "publish this site", linked from
 * outside the editor. The editor runs the same gated publish as its header button, so the Joy AI
 * Website paywall opens when the event owes it (doc/website-v2/publish-paywall.md, entry point 4).
 * Used by every publish that can't open the paywall where it is: the draft guest view's Publish
 * button (carbon runtime) and joy-web's publish surfaces outside the editor
 * (`useWebsitePublishState`).
 */
export const PUBLISH_INTENT_PARAM = 'intent';
export const PUBLISH_INTENT_VALUE = 'publish';

/** The WebsiteV2 editor. The one place to fix a site that's still generating, or failed to. */
export const getWebsiteV2EditorPath = (eventHandle: string) => `/${eventHandle}/edit/website`;

export const getWebsiteV2PublishIntentPath = (eventHandle: string, siteId: string) => {
  const params = new URLSearchParams({ [PUBLISH_INTENT_PARAM]: PUBLISH_INTENT_VALUE, [CHECKOUT_RETURN_SITE_PARAM]: siteId });
  return `${getWebsiteV2EditorPath(eventHandle)}?${params.toString()}`;
};
